'use client';

import React, { type FC } from 'react';
import { formatCreditsNumber } from '../utils/formatters';
import { FaBolt } from './icons';

interface BonusCreditsProps {
  amount: number;
  className?: string;
  showIcon?: boolean;
  iconSize?: number | string;
  iconOnly?: boolean;
  muted?: boolean;
  /** Overrides the bolt color — the default fuchsia is unreadable on magenta surfaces
   *  like `.bnc-btn-neon`, where the caller passes `text-white`. */
  iconClassName?: string;
  /** 'baseline' sits the icon on the surrounding text's baseline — for inline use next to prose. */
  align?: 'center' | 'baseline';
}

/** SHOT BAND spark counter — Credits' sibling. Magenta bolt instead of the gold coin
 *  so the club currency never reads as the main balance. */
export const BonusCredits: FC<BonusCreditsProps> = ({ amount, className, showIcon = true, iconSize = 12, iconOnly = false, muted = false, iconClassName, align = 'center' }) => {
  return (
    <span className={`inline-flex ${align === 'baseline' ? 'items-baseline' : 'items-center'} gap-1 ${className || ''}`}>
      {!iconOnly && formatCreditsNumber(amount)}
      {showIcon && <FaBolt className={`${iconClassName ?? (muted ? 'text-fuchsia-400/50' : 'text-fuchsia-400')} shrink-0`} size={iconSize} />}
    </span>
  );
};
